import Layout from "../UI/Layout/Layout";
import CareerHero from "./CareerHero";
import CareerBoxes from "./CareerBoxes";
import CareerReasons from "./CareerReasons";
import CareerContact from "./CareerContact";
import CareerOpenPositions from "./CareerOpenPositions";
import Seo from "../UI/Seo/Seo";

const Career = () => {
  return (
    <Layout authLevelRequired={false}>
      <Seo
        title="Karriere"
        description="Werden Sie Teil von Wilms Rechtsanwälte in Berlin-Tempelhof. Aktuelle Stellenangebote und Karrieremöglichkeiten in unserer Kanzlei."
        path="/karriere"
      />
      <div className="pb-32">
        <CareerHero />
        <CareerBoxes />
        <CareerReasons />
        <CareerContact />
        <CareerOpenPositions />
      </div>
    </Layout>
  );
};

export default Career;
